import { Link } from "@tanstack/react-router";
import { useAuthUser, useLogout } from "#/api/auth";
import { useBillingStatus, usePortal } from "#/api/billing";
import { UpgradeModal } from "#/components/UpgradeModal";

export function AuthNav() {
  const { data: user, isPending, isFetching } = useAuthUser();
  const { data: billing } = useBillingStatus(!!user);
  const logout = useLogout();
  const portal = usePortal();
  const isLoadingAuth = isPending || (isFetching && !user);

  return (
    <nav className="fixed left-0 right-0 top-0 z-60 flex items-center justify-between px-6 py-5">
      <Link
        to="/"
        className="flex items-center gap-2.5 text-foreground no-underline"
      >
        <div className="h-5 w-5 rounded-full border border-primary/60 shadow-[0_0_18px_rgba(180,160,220,0.25)]" />
        <span className="font-serif text-lg font-light tracking-wide">
          Ineya
        </span>
      </Link>

      <div className="flex items-center gap-3">
        {isLoadingAuth ? (
          <div className="h-8 w-16 rounded-full bg-white/5" />
        ) : user ? (
          <>
            <Link
              to="/beliefs"
              className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-medium text-muted-foreground backdrop-blur-sm transition-all hover:border-white/20 hover:text-foreground"
            >
              Your beliefs
            </Link>
            {billing?.plan === "premium" ? (
              <button
                onClick={() => portal.mutate()}
                disabled={portal.isPending}
                className="rounded-full border border-primary/30 bg-primary/10 px-4 py-2 text-xs font-medium text-primary backdrop-blur-sm transition-all hover:border-primary/50 disabled:opacity-50"
              >
                {portal.isPending ? "Opening..." : "Manage plan"}
              </button>
            ) : billing?.plan === "free" ? (
              <UpgradeModal>
                <button className="rounded-full border border-primary/30 bg-primary/10 px-4 py-2 text-xs font-medium text-primary backdrop-blur-sm transition-all hover:border-primary/50 disabled:opacity-50">
                  Go Premium
                </button>
              </UpgradeModal>
            ) : null}
            {user.picture && (
              <img
                src={user.picture}
                alt={user.name || user.email}
                className="h-7 w-7 rounded-full border border-white/10 object-cover"
              />
            )}
            <button
              onClick={() => logout.mutate()}
              disabled={logout.isPending}
              className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-medium text-muted-foreground backdrop-blur-sm transition-all hover:border-white/20 hover:text-foreground disabled:opacity-50"
            >
              {logout.isPending ? "Signing out..." : "Sign out"}
            </button>
          </>
        ) : (
          <Link
            to="/login"
            className="rounded-full border border-white/10 bg-white/[0.04] px-4 py-2 text-xs font-medium text-muted-foreground backdrop-blur-sm transition-all hover:border-white/20 hover:text-foreground"
          >
            Sign in
          </Link>
        )}
      </div>
    </nav>
  );
}
